import { render, staticRenderFns } from "./CurveGraph.vue?vue&type=template&id=70a171c5&scoped=true&"
import script from "./CurveGraph.vue?vue&type=script&lang=ts&"
export * from "./CurveGraph.vue?vue&type=script&lang=ts&"
import style0 from "./CurveGraph.vue?vue&type=style&index=0&id=70a171c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a171c5",
  null
  
)

export default component.exports